import React, { useContext, useEffect, useRef, useState } from "react";
import AmountSelector from "../components/AmountSelector";
import { Form, useLocation, useNavigate } from "react-router-dom";
import Modal from "../components/Modal";
import Logo from "../assets/imgs/Logo.png";
import { ModalContext } from '../context/ModalContext.js';
import ResponseDialog from "../components/ResponseDialog";
import {
    getDepositHistory,
    getWithdrawalHistory,
} from "../repository/HistoryRepository.js";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
    depositBalance,
    depositBalancePayFromUpi,
    depositBalancePaymentKaro,
    depositBalanceQRCode,
    transferBalance,
    withdrawBalance,
    getWithdrawLocationRequirement,
    updateUserLocation,
} from "../repository/BalanceRepository.js";
import Spinner from "../components/Spinner.jsx";
import Pagination from "../components/Pagination.jsx";
import { setAppData, setAuthDataUsersSingleValue } from "../store/features/appData/appDataSlice.js";
import QRCode from "react-qr-code";
import { getAppData } from "../repository/DataRepository.js";
import { ibrPayUPIPaymentUrl } from "../repository/PaymentRepository.js";
import NoDataFoundImage from "../assets/imgs/noDataFound.png";

const WalletHistoryTable = ({
    loading,
    data,
    currentPage,
    lastPage,
    setCurrentPage,
    perPageRecords,
    activeTab,
    onViewScreenshot
}) => {
    return (
        <>
            <div className="overflow-auto">

                <div className="px-3">
                    {
                        loading ? (
                            <div className="flex justify-center w-full p-4">
                                <div className="grid w-full place-items-center overflow-x-scroll rounded-lg lg:overflow-visible">
                                    <svg
                                        className="text-gray-300 animate-spin"
                                        viewBox="0 0 64 64"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                    >
                                        <path
                                            d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                            stroke="currentColor"
                                            strokeWidth="5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        ></path>
                                        <path
                                            d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                            stroke="currentColor"
                                            strokeWidth="5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="text-gray-600"
                                        ></path>
                                    </svg>
                                </div>
                            </div>
                        ) :
                            data?.length > 0 ?
                                data?.map((item, index) => (
                                    <div className="mb-4 rounded-xl overflow-hidden shadow-lg p-2 border border-black/30 " key={item?.id || index}>
                                        <div className="flex justify-between py-2">
                                            <div className="px-2 w-[65%]">
                                                <p className="text-sm text-[#000] font-medium">
                                                    {item?.created_at?.length ? moment(item?.created_at).format("Do MMM, YYYY") : "N/A"}
                                                </p>
                                                <p className="text-xs text-gray-600">
                                                    {item?.created_at?.length ? moment(item?.created_at).format("hh:mm A") : ""}
                                                </p>
                                            </div>
                                            <div className="px-2 w-[35^] flex justify-end items-center gap-1">
                                                {
                                                    item?.status === "pending" ? (
                                                        <span>⌛</span>
                                                    ) : item?.status === "ongoing" ? (
                                                        <span>🔄</span>
                                                    ) : item?.status === "pending_from_provider" ? (
                                                        <span>💸</span>
                                                    ) : item?.status === "success" ? (
                                                        <span>✅</span>
                                                    ) : item?.status === "failed" ? (
                                                        <span>❌</span>
                                                    ) : ""

                                                }
                                                {
                                                    item?.status === "pending" ? (
                                                        <span className="text-sm text-[#ffb300] font-semibold capitalize">{item?.status || "N/A"}</span>
                                                    ) : item?.status === "ongoing" ? (
                                                        <span className="text-sm text-blue-600 font-semibold capitalize">{item?.status || "N/A"}</span>
                                                    ) : item?.status === "pending_from_provider" ? (
                                                        <span className="text-sm text-[#9333ea] font-semibold capitalize">Processing</span>
                                                    ) : item?.status === "success" ? (
                                                        <span className="text-sm text-green-600 font-semibold capitalize">{item?.status || "N/A"}</span>
                                                    ) : item?.status === "failed" ? (
                                                        <span className="text-sm text-[#f50f0f] font-semibold capitalize">{item?.status || "N/A"}</span>
                                                    ) : ""

                                                }

                                            </div>
                                        </div>
                                        <div className="flex justify-between pb-2">
                                            <div className="px-2 w-full">
                                                <h5 className="text-lg text-[#000] font-bold">₹{item?.amount || "N/A"}</h5>
                                            </div>
                                        </div>
                                        {activeTab === "withdrawPoints" && item?.status && item?.status !== "failed" && (
                                            <div className={`px-2 py-2 mb-2 rounded-md ${item?.status === "success"
                                                ? "bg-green-50 border border-green-200"
                                                : "bg-blue-50 border border-blue-200"
                                                }`}>
                                                <p className={`text-sm text-center font-medium ${item?.status === "success" ? "text-green-800" : "text-blue-800"
                                                    }`}>
                                                    {item?.status === "pending" && (
                                                        <span>⌛ कृपया प्रतीक्षा करें, आपका request pending है।<br /><span className="text-xs">(Please wait, your request is pending)</span></span>
                                                    )}
                                                    {item?.status === "ongoing" && (
                                                        <span>🔄 आपका request approve हो गया है और जल्द ही भेजा जाएगा।<br /><span className="text-xs">(Your request is approved and will be sent soon)</span></span>
                                                    )}
                                                    {item?.status === "pending_from_provider" && (
                                                        <span>💸 आपका पैसा भेजा जा रहा है, कृपया थोड़ा इंतजार करें।<br /><span className="text-xs">(Your money is being transferred, please wait)</span></span>
                                                    )}
                                                    {item?.status === "success" && (
                                                        <span>✅ आपका withdrawal सफलतापूर्वक पूरा हो गया है।<br /><span className="text-xs">(Your withdrawal has been completed successfully)</span></span>
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                        {activeTab === "withdrawPoints" && item?.status === "failed" && item?.failed_reason && (
                                            <div className="px-2 py-3 mb-2 bg-red-50 border-2 border-red-300 rounded-md">
                                                <h5 className="text-sm text-red-700 font-bold mb-1">❌ Failed Reason (विफल होने का कारण)</h5>
                                                <p className="text-sm text-red-600 font-medium">{item?.failed_reason}</p>
                                            </div>
                                        )}
                                        {activeTab === "withdrawPoints" && item?.status === "success" && item?.payment_ss_link && (
                                            <div className="flex justify-center border-t border-black py-2">
                                                <button
                                                    type="button"
                                                    onClick={() => onViewScreenshot(item?.payment_ss_link)}
                                                    className="px-4 py-2 text-sm font-semibold text-white bg-blue-500 hover:bg-blue-600 rounded-md transition"
                                                >
                                                    View Payment Screenshot
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ))
                                :
                                <div className="w-full flex py-4 flex-col items-center gap-2">
                                    <img src={NoDataFoundImage} width={100} alt="" />
                                    <p className="text-gray-400 font-bold text-sm">No Data Found</p>

                                </div>
                    }

                </div>
            </div>
            {!loading && data.length > 0 && (
                <Pagination
                    currentPage={currentPage}
                    lastPage={lastPage}
                    onChange={setCurrentPage}
                />
            )}
        </>
    );
};

const Wallet = () => {
    const location = useLocation();
    const navigate = useNavigate();
    let { appData, user } = useSelector((state) => state.appData.appData);

    let [activeTab, setActiveTab] = useState("addPoints");
    let [isDepositModal, setDepositModal] = useState(false);
    let [paymentMethodModal, setPaymentMethodModal] = useState(false);
    let [bankAccountType, setBankAccountType] = useState("permanent");
    let [method, setMethod] = useState("bank");
    let [addBalanceMethod, setAddBalanceMethod] = useState("bank");
    let [addBalanceMethodData, setBalanceMethodData] = useState(null)
    let [withdrawLoading, setWithdrawLoading] = useState(false);
    let withdrawInProgressRef = useRef(false);
    let [showLocationConsent, setShowLocationConsent] = useState(false);
    let locationConsentResolver = useRef(null);
    let [locationConsentLoading, setLocationConsentLoading] = useState(false);
    let locationRequestInProgressRef = useRef(false);
    let hasGrantedLocationInSessionRef = useRef(false);
    let [withdrawLocationRequirement, setWithdrawLocationRequirement] = useState(null);
    let [depositLoading, setDepositLoading] = useState(false);
    let [qrCodeModalURL, setQRCodeModalURL] = useState(null);
    let [screenshotModalURL, setScreenshotModalURL] = useState(null);
    let [isDialogOpen, setIsDialogOpen] = useState(false);
    let [dialogSuccess, setDialogSuccess] = useState(false);
    let [dialogMessage, setDialogMessage] = useState("");

    let defaultWithdrawDetails = localStorage.getItem("withdraw_details") ? JSON.parse(localStorage.getItem("withdraw_details")) : null;

    let [loading, setLoading] = useState(false);
    let [dataLoading, setDataLoading] = useState(true);

    let walletWithdrawForm = useRef(null);

    let [depositHistoryData, setDepositHistoryData] = useState([]);
    let [withdrawHistoryData, setWithdrawHistoryData] = useState([]);
    let [depositLastPage, setDepositLastPage] = useState(0);
    let [withdrawLastPage, setWithdrawLastPage] = useState(0);
    let [currentPage, setCurrentPage] = useState(1);
    const [accountIFSCCode, setAccountIFSCCode] = useState(defaultWithdrawDetails?.account_ifsc_code || "");

    // Pending withdrawal info
    let [pendingWithdrawalInfo, setPendingWithdrawalInfo] = useState(null);
    let [showPendingDialog, setShowPendingDialog] = useState(false);
    let [shouldShowPendingOnTabSwitch, setShouldShowPendingOnTabSwitch] = useState(false);

    // Toggle this to true to bypass the hourly limit (for testing)
    const BYPASS_HOURLY_LIMIT = false;


    let [depositAmount, setDepositAmount] = useState("");
    let [withdrawAmount, setWithdrawAmount] = useState("");
    let [depositAmountError, setDepositAmountError] = useState("");
    let [withdrawAmountError, setWithdrawAmountError] = useState("");

    let [perPageRecords, setPerPageRecords] = useState(10);

    let { toggleSuccessModalOpen, setSuccessMessage } = useContext(ModalContext)

    let dispatch = useDispatch();
    const storedUser = JSON.parse(localStorage.getItem("authUser")) || {};

    const currentUser = user?.phone ? user : storedUser;

    useEffect(() => {
        setMethod(
            appData.enable_upi_withdraw === 1
                ? "upi"
                : appData.enable_bank_withdraw === 1
                    ? "bank"
                    : ""
        );
    }, [appData]);

    const toggleDepositModal = () => {
        setDepositModal((prevState) => !prevState);
    };


    const _getDepositHistory = async (page) => {
        let { data } = await getDepositHistory({ page });
        if (data.error === false) {
            let {
                depositHistory: { data: depositHistoryData, last_page, per_page },
            } = data.response;
            setDepositHistoryData(depositHistoryData);
            setDepositLastPage(last_page);
            setPerPageRecords(per_page);
        } else {
            toast.error(data.message);
        }
    };

    const _getWithdrawHistory = async (page) => {
        let { data } = await getWithdrawalHistory({ page });
        if (data.error === false) {
            let {
                depositHistory: { data: depositHistoryData, per_page, last_page },
                pendingInfo
            } = data.response;
            depositHistoryData = depositHistoryData.map((dhd) => ({
                ...dhd,
                type: dhd.withdraw_mode,
            }));
            setWithdrawHistoryData(depositHistoryData);
            setWithdrawLastPage(last_page);
            setPerPageRecords(per_page);

            // Store pending withdrawal info
            if (pendingInfo && pendingInfo.count > 0) {
                setPendingWithdrawalInfo(pendingInfo);

                // Check if we should show dialog based on hourly limit
                if (shouldShowPendingDialog()) {
                    // If currently on withdrawal tab, show immediately
                    if (activeTab === "withdrawPoints") {
                        setShowPendingDialog(true);
                        localStorage.setItem('pending_withdrawal_dialog_last_shown', Date.now().toString());
                    } else {
                        // If on another tab, flag to show when they switch to withdrawal tab
                        setShouldShowPendingOnTabSwitch(true);
                    }
                }
            } else {
                setPendingWithdrawalInfo(null);
                setShouldShowPendingOnTabSwitch(false);
            }
        } else {
            toast.error(data.message);
        }
    };

    // Check if we should show the pending withdrawal dialog
    const shouldShowPendingDialog = () => {
        if (BYPASS_HOURLY_LIMIT) return true;

        const lastShownTime = localStorage.getItem('pending_withdrawal_dialog_last_shown');
        if (!lastShownTime) return true;

        const fifteenMinutesInMs = 15 * 60 * 1000; // 15 minutes
        const timeDiff = Date.now() - parseInt(lastShownTime);

        return timeDiff >= fifteenMinutesInMs;
    };

    // Handle switching to withdrawal tab
    const handleWithdrawalTabClick = () => {
        setActiveTab("withdrawPoints");
        setCurrentPage(1);
        // Dialog will be shown by useEffect after data loads
    };

    useEffect(() => {
        let getData = async () => {
            try {
                setDataLoading(true);
                await _getDepositHistory(currentPage);
                await _getWithdrawHistory(currentPage);

            } catch (err) {
                toast.error(err.message);
            } finally {
                setDataLoading(false);
            }
        };
        getData();
    }, [currentPage]);

    const onHandleTransferSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            let phone = e.target["phone"].value;
            let amount = e.target["amount"].value;
            let { data } = await transferBalance({ phone, amount });
            if (data.error) {
                toast.error(data.message);
            } else {
                toast.success(data.message);
                let { response } = data;
                setDataLoading(true);
                await _getWithdrawHistory(currentPage);
                dispatch(
                    setAuthDataUsersSingleValue({
                        key: "balance",
                        value: response.balance_left,
                    })
                );
                toggleDepositModal();
            }
        } catch (err) {
            toast.error(err.message);
        } finally {
            setLoading(false);
            setDataLoading(false);
        }
    };

    const _addBalanceUPI = async (e) => {
        e.preventDefault();
        const upiId = e?.target?.upi_id?.value;
        if (upiId.trim()?.length > 0) {
            setBalanceMethodData({ upi: upiId });
            setPaymentMethodModal(false)
        }
        else {
            toast.error("Please enter a UPI ID.");
            e.target.upi_id.value = "";
            setBalanceMethodData({ upi: null });
        }
    }
    const _addBalanceBank = async (event) => {
        event.preventDefault();
        const formData = {
            bank_name: event.target.bank_name.value,
            account_holder_name: event.target.account_holder_name.value,
            account_number: event.target.account_number.value,
            account_ifsc_code: event.target.account_ifsc_code.value
        };
        setBalanceMethodData({ bank: formData });
    }


    const handleDepositSubmit = async (e) => {
        e.preventDefault();

        // Validate deposit amount
        const minDeposit = parseFloat(appData.min_deposit) || 0;
        const depositAmountValue = parseFloat(depositAmount) || 0;

        if (!depositAmount || depositAmountValue <= 0) {
            setDepositAmountError("कृपया एक वैध राशि दर्ज करें। (Please enter a valid amount)");
            return;
        }

        if (depositAmountValue < minDeposit) {
            setDepositAmountError(`न्यूनतम जमा राशि ₹${minDeposit} है। (Minimum deposit amount is ₹${minDeposit})`);
            return;
        }

        setDepositAmountError("");

        // if(addBalanceMethod==="upi"){
        //   if(addBalanceMethodData?.upi?.length>0){
        //     console.log("UPI ID : ",addBalanceMethodData?.upi)
        //   }
        //   else{
        //     setPaymentMethodModal(true);
        //     toast.error("Add a UPI ID first!")
        //   }
        // }

        // else{
        //   if(addBalanceMethodData?.bank){
        //     console.log("UPI ID : ",addBalanceMethodData?.bank)
        //   }
        //   else{
        //     setPaymentMethodModal(true);
        //     toast.error("Add bank details first!")
        //   }
        // }
        try {
            setDepositLoading(true);
            let payload = {
                amount: depositAmount,
            };
            let paymentMethod = appData?.payment_method
            if (paymentMethod === "auto") {
                let { data } = await depositBalance(payload);
                if (data.error) {
                    setDialogMessage(data.message);
                    setDialogSuccess(false);
                    setIsDialogOpen(true);
                } else {
                    navigate("/payment/?pageName=deposit" + "&pageUrl=" + data?.response?.payment_url);

                    dispatch(
                        setAuthDataUsersSingleValue({
                            key: "balance",
                            value: data.response.balance_left,
                        })
                    );
                }
            }
            else if (paymentMethod === "manual") {
                let baseDomain = appData?.base_domain;
                let url = `${baseDomain}/payment/${user?.id}/${payload?.amount}`
                navigate("/payment/?pageName=deposit" + "&pageUrl=" + url);
            } else if (paymentMethod === "ibr_pay") {
                let { data } = await ibrPayUPIPaymentUrl(payload);
                if (data.error) {
                    setDialogMessage(data.message);
                    setDialogSuccess(false);
                    setIsDialogOpen(true);
                } else {
                    setQRCodeModalURL(data?.response?.upiIntent)
                }
            } else if (paymentMethod === "payment_karo") {
                let { data } = await depositBalancePaymentKaro(payload);
                if (data.error) {
                    setDialogMessage(data.message);
                    setDialogSuccess(false);
                    setIsDialogOpen(true);
                } else {
                    navigate("/payment/?pageName=deposit" + "&pageUrl=" + data?.response?.payment_url);
                }
            } else if (paymentMethod === "pay_from_upi") {
                let { data } = await depositBalancePayFromUpi(payload);
                if (data.error) {
                    setDialogMessage(data.message);
                    setDialogSuccess(false);
                    setIsDialogOpen(true);
                } else {
                    navigate("/payment/?pageName=deposit" + "&pageUrl=" + data?.response?.payment_url);
                }
            }
            else {
                let { data } = await depositBalanceQRCode(payload);
                if (data.error) {
                    setDialogMessage(data.message);
                    setDialogSuccess(false);
                    setIsDialogOpen(true);
                } else {
                    setQRCodeModalURL(data?.response?.upiString)
                }
            }
            setDataLoading(true);
            await _getDepositHistory(currentPage);

            e.target.reset();

        } catch (err) {
            setDialogMessage(err.message);
            setDialogSuccess(false);
            setIsDialogOpen(true);
        } finally {
            setDepositLoading(false);
            setDataLoading(false);
        }
    };
    const finishLocationConsent = (result) => {
        if (result?.position) hasGrantedLocationInSessionRef.current = true;
        locationRequestInProgressRef.current = false;
        setLocationConsentLoading(false);
        setShowLocationConsent(false);
        if (locationConsentResolver.current) {
            locationConsentResolver.current(result);
            locationConsentResolver.current = null;
        }
    };

    const closeLocationConsent = () => {
        if (!locationRequestInProgressRef.current) finishLocationConsent({ cancelled: true });
    };

    const askLocationConsent = () => new Promise((resolve) => {
        locationConsentResolver.current = resolve;
        setShowLocationConsent(true);
    });

    const isAndroidApp = Boolean(window.AndroidApp);
    const getAndroidLocation = () => new Promise((resolve, reject) => {
        if (typeof window.AndroidApp?.requestLocation !== 'function') {
            reject({ code: 2, message: 'Please update the Android app to enable location access.' });
            return;
        }
        const phone = user?.phone || storedUser?.phone;
        if (!phone || !window.crypto?.getRandomValues) {
            reject({ code: 2, message: 'Could not start the Android location request.' });
            return;
        }
        const captureId = window.crypto.randomUUID
            ? window.crypto.randomUUID()
            : (() => {
                const bytes = window.crypto.getRandomValues(new Uint8Array(16));
                bytes[6] = (bytes[6] & 0x0f) | 0x40;
                bytes[8] = (bytes[8] & 0x3f) | 0x80;
                const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
                return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
            })();
        const cleanup = () => {
            window.removeEventListener('androidLocationResult', onResult);
            window.clearTimeout(timeout);
        };
        const onResult = (event) => {
            if (event.detail?.captureId !== captureId) return;
            cleanup();
            if (event.detail.error) {
                reject(event.detail.error);
            } else {
                resolve({
                    coords: {
                        latitude: event.detail.latitude,
                        longitude: event.detail.longitude,
                        accuracy: event.detail.accuracy,
                    },
                    captureId,
                });
            }
        };
        const timeout = window.setTimeout(() => {
            cleanup();
            reject({ code: 3, message: 'Android location request timed out.' });
        }, 30000);
        window.addEventListener('androidLocationResult', onResult);
        try {
            window.AndroidApp.requestLocation(phone, captureId);
        } catch (_) {
            cleanup();
            reject({ code: 2, message: 'Could not start the Android location request.' });
        }
    });

    const getCurrentLocation = () => new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject({ code: 2 });
            return;
        }
        navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: 20000,
        });
    });

    const hasGrantedLocationPermission = async () => {
        if (isAndroidApp) {
            try {
                return window.AndroidApp?.hasLocationPermission?.() === true;
            } catch (_) {
                return false;
            }
        }
        if (!navigator.permissions?.query) return hasGrantedLocationInSessionRef.current;
        try {
            const permission = await navigator.permissions.query({ name: 'geolocation' });
            return permission.state === 'granted';
        } catch (_) {
            return hasGrantedLocationInSessionRef.current;
        }
    };

    const requestLocationFromConsentButton = () => {
        if (locationRequestInProgressRef.current) return;
        locationRequestInProgressRef.current = true;
        setLocationConsentLoading(true);
        if (isAndroidApp) {
            getAndroidLocation().then(
                (position) => finishLocationConsent({ position }),
                (error) => finishLocationConsent({ error })
            );
            return;
        }
        if (!navigator.geolocation) {
            finishLocationConsent({ error: { code: 2 } });
            return;
        }

        // Called directly from the user's button click for Safari/iOS permission handling.
        navigator.geolocation.getCurrentPosition(
            (position) => finishLocationConsent({ position }),
            (error) => finishLocationConsent({ error }),
            { enableHighAccuracy: true, maximumAge: 0, timeout: 20000 }
        );
    };

    const showLocationFailure = async (locationError, allowSavedLocation = false) => {
        const status = locationError?.code === 1 ? 'denied'
            : locationError?.code === 3 ? 'timeout' : 'unavailable';
        try {
            await updateUserLocation({ status });
        } catch (_) {
            // The withdrawal endpoint still verifies whether a saved location may be used.
        }
        if (allowSavedLocation) return true;
        if (isAndroidApp) {
            setDialogMessage(locationError?.message || (status === 'denied'
                ? 'Location permission was denied. Allow it in Android settings and try again.'
                : 'Could not get device location. Turn on location and try again.'));
            setDialogSuccess(false);
            setIsDialogOpen(true);
            return false;
        }
        setDialogMessage(status === 'denied'
            ? 'आपने location permission नहीं दी, इसलिए withdraw नहीं हो पाया।\nकृपया browser की location setting allow करके दोबारा प्रयास करें।'
            : 'आपकी location नहीं मिल पाई, इसलिए withdraw नहीं हो पाया।\nकृपया device location चालू करके दोबारा प्रयास करें।');
        setDialogSuccess(false);
        setIsDialogOpen(true);
        return false;
    };

    const handleWithdrawSubmit = async (e) => {
        e.preventDefault();
        if (withdrawInProgressRef.current) return;

        let maximumWithdrawAmount = appData?.enable_withdrawabale_balance_condition
            ? (user?.withdrawable_balance ? parseFloat(user?.withdrawable_balance) : 0)
            : (user?.balance ? parseFloat(user?.balance) : 0);

        // Validate withdrawal amount
        const minWithdraw = parseFloat(appData?.min_withdraw) || 0;
        const withdrawAmountValue = parseFloat(withdrawAmount) || 0;

        if (!withdrawAmount || withdrawAmountValue <= 0) {
            setWithdrawAmountError("कृपया एक वैध राशि दर्ज करें। (Please enter a valid amount)");
            return;
        }

        if (withdrawAmountValue < minWithdraw) {
            setWithdrawAmountError(`न्यूनतम निकासी राशि ₹${minWithdraw} है। (Minimum withdrawal amount is ₹${minWithdraw})`);
            return;
        }

        if (withdrawAmount > maximumWithdrawAmount) {
            toast.error("Can't withdraw more than ₹" + maximumWithdrawAmount.toFixed(2));
            return;
        }

        setWithdrawAmountError("");
        // The requirement is preloaded when the user opens Withdraw. Starting this
        // immediately inside the submit event lets Safari display its native prompt.
        const cachedRequirement = withdrawLocationRequirement;
        const directLocationPromise = cachedRequirement?.required && !cachedRequirement.show_dialog
            ? (isAndroidApp ? getAndroidLocation() : getCurrentLocation())
            : null;
        try {
            withdrawInProgressRef.current = true;
            setWithdrawLoading(true);
            let locationRequirement = cachedRequirement;
            if (!locationRequirement) {
                const { data: locationRequirementData } = await getWithdrawLocationRequirement();
                if (locationRequirementData.error) {
                    throw new Error(locationRequirementData.message);
                }
                locationRequirement = locationRequirementData.response;
                setWithdrawLocationRequirement(locationRequirement);
            }
            let withdrawalLocation = null;

            if (locationRequirement?.required) {
                try {
                    let position;
                    if (locationRequirement.show_dialog) {
                        if (await hasGrantedLocationPermission()) {
                            position = await (isAndroidApp ? getAndroidLocation() : getCurrentLocation());
                        } else {
                            const result = await askLocationConsent();
                            if (result?.cancelled) return;
                            if (result?.error) throw result.error;
                            position = result.position;
                        }
                    } else if (directLocationPromise) {
                        position = await directLocationPromise;
                    } else {
                        position = await (isAndroidApp ? getAndroidLocation() : getCurrentLocation());
                    }
                    withdrawalLocation = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        accuracy_meters: position.coords.accuracy,
                        ...(position.captureId ? { capture_id: position.captureId } : {}),
                    };
                    hasGrantedLocationInSessionRef.current = true;
                } catch (locationError) {
                    const mayContinue = await showLocationFailure(
                        locationError,
                        locationRequirement.allow_saved_location
                    );
                    if (!mayContinue) return;
                }
            }
            let payload = {
                mode: method,
                amount: withdrawAmount,
                location: withdrawalLocation,
            };
            if (method === "upi") {
                let upiName = e.target["upi_name"].value;
                let upiId = e.target["upi_id"].value;
                payload = { ...payload, upiName, upiId };

            } else if (method === "bank") {
                let bankName = e.target["bank_name"].value;
                let accountHolderName = e.target["account_holder_name"].value;
                let accountNumber = e.target["account_number"].value;
                let accountIFSCCode = e.target["account_ifsc_code"].value;
                payload = {
                    ...payload,
                    bankName,
                    accountHolderName,
                    accountNumber,
                    accountIFSCCode,
                };
            }
            let { data } = await withdrawBalance(payload);
            if (data.error) {
                setDialogMessage(data.message);
                setDialogSuccess(false);
                setIsDialogOpen(true);
            } else {
                e.target.reset();
                let { response } = data;
                setDataLoading(true);
                setDialogMessage(data.message);
                setDialogSuccess(true);
                setIsDialogOpen(true);
                await _getWithdrawHistory(currentPage);
                setWithdrawLocationRequirement(null);
                dispatch(
                    setAuthDataUsersSingleValue({
                        key: "balance",
                        value: response?.balance_left || 0,
                    })
                );
                dispatch(
                    setAuthDataUsersSingleValue({
                        key: "withdrawable_balance",
                        value: response?.withdrwabale_balance || 0,
                    })
                );

                if (data?.response?.withdrwabale_balance) {
                    localStorage.setItem("", JSON.stringify(data?.response?.withdrwabale_balance));
                }

                //also save the withdraw details
                localStorage.setItem("withdraw_details", JSON.stringify(response?.withdraw_details));
            }
        } catch (err) {
            setDialogMessage(err?.response?.data?.message || err.message);
            setDialogSuccess(false);
            setIsDialogOpen(true);
        } finally {
            withdrawInProgressRef.current = false;
            setWithdrawLoading(false);
            setDataLoading(false)
        }
    };

    const toggleQRCodeModal = () => {
        setQRCodeModalURL(null)
    }

    const handleViewScreenshot = (url) => {
        setScreenshotModalURL(url);
    }

    const toggleScreenshotModal = () => {
        setScreenshotModalURL(null);
    }


    useEffect(() => {
        // Extract query params
        const queryParams = new URLSearchParams(location.search);
        const tab = queryParams.get("tab");

        // Set the active tab based on the query parameter
        if (tab) {
            setActiveTab(tab);
        }
    }, [location.search]); // Runs whenever the query string changes

    useEffect(() => {
        if (activeTab !== "withdrawPoints") return;

        getWithdrawLocationRequirement()
            .then(({ data }) => {
                if (!data.error) setWithdrawLocationRequirement(data.response);
            })
            .catch(() => setWithdrawLocationRequirement(null));
    }, [activeTab]);

    // Show pending dialog when switching to withdrawal tab (if flagged)
    useEffect(() => {
        if (activeTab === "withdrawPoints" && shouldShowPendingOnTabSwitch && pendingWithdrawalInfo) {
            setShowPendingDialog(true);
            localStorage.setItem('pending_withdrawal_dialog_last_shown', Date.now().toString());
            setShouldShowPendingOnTabSwitch(false); // Reset flag
        }
    }, [activeTab, shouldShowPendingOnTabSwitch, pendingWithdrawalInfo]);

    return (
        <>
            <Modal isOpen={qrCodeModalURL !== null} toggle={toggleQRCodeModal}>
                <div className="flex p-8 items-center flex-col">
                    {qrCodeModalURL !== null &&
                        <QRCode value={qrCodeModalURL} />
                    }
                    <button onClick={async () => {
                        toggleQRCodeModal();
                        // Update with balance api after 5sec
                        let { data } = await getAppData();
                        if (!data.error) {
                            dispatch(setAppData(data.response));
                        }
                    }} className="py-1 px-12 rounded-full bg-green-500 hover:bg-green-600 transition text-white mt-3">I have paid</button>

                </div>
            </Modal>
            <Modal isOpen={screenshotModalURL !== null} toggle={toggleScreenshotModal}>
                <div className="relative w-[90vw] md:max-w-[600px] mx-auto">
                    <div className="flex justify-between items-center p-3 bg-primary text-white">
                        <h3 className="text-lg font-semibold">Payment Screenshot</h3>
                        <button
                            type="button"
                            onClick={toggleScreenshotModal}
                            className="text-white hover:text-gray-200"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="w-6 h-6"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M6 18 18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className="p-4 flex justify-center items-center bg-gray-100 overflow-hidden">
                        {screenshotModalURL && (
                            <img
                                src={screenshotModalURL}
                                alt="Payment Screenshot"
                                className="w-full h-auto max-h-[70vh] object-contain"
                            />
                        )}
                    </div>
                </div>
            </Modal>
            <div className="pb-8">
                <div className="grid grid-cols-2 text-sm">
                    <button
                        className={`w-full p-2 font-semibold text-white ${activeTab === "addPoints"
                            ? "bg-greenLight border-[1px] border-black"
                            : "bg-orange"
                            }`}
                        onClick={async () => {
                            setActiveTab("addPoints");
                            setCurrentPage(1);
                        }}
                    >
                        Add Balance
                    </button>
                    <button
                        className={`w-full p-2 font-semibold text-white ${activeTab === "withdrawPoints"
                            ? "bg-greenLight border-[1px] border-black"
                            : "bg-orange"
                            }`}
                        onClick={handleWithdrawalTabClick}
                    >
                        Withdraw Balance
                    </button>
                </div>
                {activeTab === "addPoints" ? (
                    <form onSubmit={handleDepositSubmit}>
                        <AmountSelector
                            value={depositAmount}
                            onChange={(value) => {
                                setDepositAmount(value);
                                setDepositAmountError("");
                            }}
                            minAmount={appData.min_deposit}
                            placeholder="Add Amount"
                            setPaymentMethodModal={setPaymentMethodModal}
                            addBalanceMethod={addBalanceMethod}
                            appData={appData}
                        />

                        {depositAmountError && (
                            <div className="px-3 mt-2">
                                <div className="px-3 py-3 bg-red-50 border-2 border-red-400 rounded-lg shadow-md">
                                    <div className="flex items-center justify-center gap-2">
                                        <span className="text-2xl">⚠️</span>
                                        <p className="text-sm text-red-700 font-bold text-center">
                                            {depositAmountError}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {
                            appData?.self_recharge_bonus > 0 ?
                                <p className="px-3 mt-2 text-xs text-center text-primary">
                                    रिचार्ज करें और पाएं {appData?.self_recharge_bonus}% एक्स्ट्रा बैलेंस।
                                    <br /> First time offer only
                                </p>
                                : null
                        }
                        <div className="flex px-3 mt-2 justify-center w-full">
                            <button
                                type="submit"
                                className="w-full px-4 py-1 mt-2 text-white border-0 rounded-md mb-3 bg-greenLight"
                            >
                                {depositLoading ? <Spinner /> : "Add Balance"}
                            </button>

                        </div>
                    </form>
                ) : (
                    <form ref={walletWithdrawForm} onSubmit={handleWithdrawSubmit}>

                        <AmountSelector
                            value={withdrawAmount}
                            onChange={(value) => {
                                setWithdrawAmount(value);
                                setWithdrawAmountError("");
                            }}
                            minAmount={appData?.min_withdraw}
                            placeholder="Withdraw Amount"
                            user={user}
                            appData={appData}
                        />

                        {withdrawAmountError && (
                            <div className="px-3 mt-2">
                                <div className="px-3 py-3 bg-red-50 border-2 border-red-400 rounded-lg shadow-md">
                                    <div className="flex items-center justify-center gap-2">
                                        <span className="text-2xl">⚠️</span>
                                        <p className="text-sm text-red-700 font-bold text-center">
                                            {withdrawAmountError}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                        <p className="px-3 mt-2 mb-2 text-sm font-semibold text-center text-black">
                            Enter Withdraw Details
                        </p>
                        {/* <div className="flex justify-center gap-3 px-2">
              <label className="inline-flex items-center gap-1">
                <input
                  type="radio"
                  name="bankAccountType"
                  checked={bankAccountType === "permanent"}
                  onChange={() => setBankAccountType("permanent")}
                  value={"permanent"}
                />
                <small>Permanent</small>
              </label>
              <label className="inline-flex items-center gap-1">
                <input
                  type="radio"
                  name="bankAccountType"
                  checked={bankAccountType === "temporary"}
                  onChange={() => {
                    walletWithdrawForm.current.reset();
                    setBankAccountType("temporary")
                  }}
                  value={"temporary"}
                />
                <small>Temporary</small>
              </label>
            </div> */}
                        {appData.enable_upi_withdraw === 1 &&
                            appData.enable_bank_withdraw === 1 && (
                                <div className="flex flex-col px-3">
                                    {/* <label className="text-sm font-bold">Withdrawal Method</label> */}
                                    <select
                                        className="w-[100%] px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                                        name="method"
                                        id="method"
                                        required
                                        value={method}
                                        onChange={(e) => setMethod(e.target.value)}
                                    >
                                        <option value={""}>Select Method</option>
                                        {appData.enable_upi_withdraw === 1 && (
                                            <option value={"upi"}>UPI</option>
                                        )}
                                        {appData.enable_bank_withdraw === 1 && (
                                            <option value={"bank"}>Bank</option>
                                        )}
                                    </select>
                                </div>
                            )}
                        {method === "upi" ? (
                            <div className="px-3 text-sm">
                                <div className="flex flex-col">
                                    <input
                                        className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                                        type="text"
                                        placeholder="UPI Name"
                                        name="upi_name"
                                        id="upi_name"
                                        key={"upi_name"}
                                        defaultValue={defaultWithdrawDetails?.upi_name || ""}
                                        required
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <input
                                        className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                                        type="text"
                                        placeholder="UPI id"
                                        name="upi_id"
                                        id="upi_id"
                                        key={"upi_id"}
                                        defaultValue={defaultWithdrawDetails?.upi_id || ""}
                                        required
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="px-3 text-sm">
                                <div className="flex flex-col">
                                    <input
                                        className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                                        type="text"
                                        placeholder="Enter Bank Name"
                                        name="bank_name"
                                        id="bank_name"
                                        key="bankName"
                                        defaultValue={defaultWithdrawDetails?.bank_name || ""}
                                        required
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <input
                                        className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                                        type="text"
                                        placeholder="Enter Account Holder Name"
                                        name="account_holder_name"
                                        id="account_holder_name"
                                        defaultValue={defaultWithdrawDetails?.account_holder_name || ""}
                                        required
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <input
                                        className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                                        type="number"
                                        placeholder="Enter Account Number"
                                        name="account_number"
                                        id="account_number"
                                        required
                                        defaultValue={defaultWithdrawDetails?.account_number || ""}
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <input
                                        className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                                        type="text"
                                        placeholder="Enter IFSC Code"
                                        name="account_ifsc_code"
                                        id="account_ifsc_code"
                                        required
                                        onChange={(e) => {
                                            setAccountIFSCCode(e.target.value.toUpperCase().replace(/\s+/g, ''))
                                        }}
                                        value={accountIFSCCode}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="p-3">
                            {
                                (() => {
                                    const maxAmount = appData?.enable_withdrawabale_balance_condition
                                        ? parseFloat(user?.withdrawable_balance || 0)
                                        : parseFloat(user?.balance || 0);
                                    return withdrawAmount > maxAmount ? (
                                        <p className="text-red-500 text-center text-sm">Your balance is not sufficient for withdrawal.</p>
                                    ) : null;
                                })()
                            }
                            <button
                                type="submit"
                                disabled={withdrawLoading}
                                className={`w-full px-4 py-1 mt-2 text-white border-0 rounded-md 
                                ${(() => {
                                        const maxAmount = appData?.enable_withdrawabale_balance_condition
                                            ? parseFloat(user?.withdrawable_balance || 0)
                                            : parseFloat(user?.balance || 0);
                                        return withdrawAmount > maxAmount ? " bg-gray-500 " : "bg-greenLight";
                                    })()}`}
                            // disabled={withdrawAmount>parseFloat(user?.withdrawable_balance) ? true :false}
                            >
                                {withdrawLoading ? <Spinner /> : "Withdraw"}
                            </button>
                        </div>
                    </form>
                )}

                {
                    appData?.invite_system_enable && activeTab === "addPoints" ?
                        <div className="text-center py-1">
                            <button
                                onClick={() => navigate("/invite-and-earn")}
                                className="text-primary font-bold text-sm blinkText hover:text-blue-700 transition-colors"
                                style={{ fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif' }}
                            >
                                🎁 {`${appData?.invite_percentage_bet}% Bet कमीशन पाएं Invite करके`} 🔥
                            </button>
                        </div>
                        : null
                }

                <p className="p-3 mt-3 font-semibold text-center text-primary text-md border-t border-black/60">
                    {activeTab === "addPoints" ? "Deposit" : "Withdraw"} History
                </p>

                <WalletHistoryTable
                    currentPage={currentPage}
                    setCurrentPage={
                        setCurrentPage
                    }
                    loading={dataLoading}
                    perPageRecords={perPageRecords}
                    lastPage={
                        activeTab === "addPoints" ? depositLastPage : withdrawLastPage
                    }
                    data={
                        activeTab === "addPoints" ? depositHistoryData : withdrawHistoryData
                    }
                    activeTab={activeTab}
                    onViewScreenshot={handleViewScreenshot}
                />
                <Modal isOpen={isDepositModal} toggle={toggleDepositModal}>
                    <form onSubmit={onHandleTransferSubmit}>
                        <div className="grid grid-cols-3 p-2 font-semibold text-white bg-primary">
                            <div></div>
                            <div className="text-center">Transfer</div>
                            <div className="flex justify-end">
                                <button type="button" onClick={toggleDepositModal}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="w-6 h-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6 18 18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="px-3 pb-3 text-sm">
                            <div className="flex justify-center">
                                <img src={Logo} alt="Logo" className="w-24 h-24" />
                            </div>
                            <p className="p-1 mt-1 font-semibold text-center text-white rounded bg-primary">
                                यहां से आप अपने POINT अपने दोस्तो की ID मैं डाल सकते हो
                            </p>
                            <input
                                type="number"
                                className="w-full p-1 px-2 mt-3 border rounded border-black/40 outline-0 focus:border-primary"
                                placeholder="Enter Mobile Number"
                                name="phone"
                                required
                            ></input>
                            <input
                                type="number"
                                className="w-full p-1 px-2 mt-1 border rounded border-black/40 outline-0 focus:border-primary"
                                placeholder="Amount"
                                name="amount"
                                required
                                min={appData?.min_transfer}
                            ></input>
                            <button
                                type="submit"
                                className="w-full h-10 p-1 mt-2 font-semibold text-center text-white rounded shadow text-md bg-primary"
                            >
                                {loading ? <Spinner /> : "Submit"}
                            </button>
                        </div>
                    </form>
                </Modal>

                <Modal isOpen={showLocationConsent} toggle={closeLocationConsent} zIndex={60}>
                    <div className="relative w-[90vw] max-w-[420px] mx-auto overflow-hidden rounded-2xl bg-white shadow-2xl">
                        <button type="button" onClick={closeLocationConsent}
                            aria-label="Close location request"
                            className="absolute right-3 top-3 rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
                            ✕
                        </button>
                        <div className="bg-gradient-to-br from-emerald-600 to-teal-700 px-6 pb-7 pt-9 text-center text-white">
                            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-white/20 text-3xl">📍</div>
                            <h3 className="text-xl font-bold">Location Permission</h3>
                            <p className="mt-2 text-sm leading-6">Withdraw सुरक्षित तरीके से पूरा करने के लिए आपकी मौजूदा location चाहिए। यह आपके account में save होगी और verification के लिए admin को दिखाई देगी।</p>
                        </div>
                        <div className="space-y-3 p-5">
                            <p className="text-center text-sm text-gray-600">नीचे बटन दबाने पर {isAndroidApp ? 'Android app' : 'browser'} आपसे location की permission मांगेगा।</p>
                            <button type="button" onClick={requestLocationFromConsentButton}
                                disabled={locationConsentLoading}
                                className="flex w-full items-center justify-center gap-2 rounded-xl bg-emerald-600 px-4 py-3 font-semibold text-white hover:bg-emerald-700 disabled:cursor-wait disabled:opacity-75">
                                {locationConsentLoading && <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" aria-hidden="true" />}
                                {locationConsentLoading ? 'Getting location...' : 'Enable Location Permission'}
                            </button>
                            <button type="button" onClick={closeLocationConsent} disabled={locationConsentLoading}
                                className="w-full rounded-xl border border-gray-200 px-4 py-2 font-medium text-gray-600">
                                Cancel Withdraw
                            </button>
                        </div>
                    </div>
                </Modal>

                <ResponseDialog
                    isOpen={isDialogOpen}
                    isSuccess={dialogSuccess}
                    message={dialogMessage}
                    onClose={() => {
                        setIsDialogOpen(false);
                        setDialogMessage("");
                    }}
                    showTelegram={dialogSuccess}
                    telegramLink={appData?.telegram_link}
                />

                {/* Pending Withdrawal Info Dialog */}
                <Modal isOpen={showPendingDialog} toggle={() => setShowPendingDialog(false)}>
                    <div className="relative w-[90vw] md:max-w-[420px] mx-auto bg-white rounded-xl overflow-hidden shadow-2xl">
                        {pendingWithdrawalInfo && (
                            <>
                                {/* Close Button */}
                                <button
                                    type="button"
                                    onClick={() => setShowPendingDialog(false)}
                                    className="absolute top-3 right-3 z-10 bg-white/90 hover:bg-white rounded-full p-1.5 shadow-md transition"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="w-5 h-5 text-gray-700">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                                    </svg>
                                </button>

                                {/* Header with Icon */}
                                <div className="bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700 px-6 pt-8 pb-6 text-center">
                                    <div className="bg-white/20 backdrop-blur-sm rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                                        <div className="text-5xl">⏳</div>
                                    </div>
                                    <h3 className="text-white text-2xl font-bold mb-3 leading-tight">
                                        {pendingWithdrawalInfo.count} Withdrawal{pendingWithdrawalInfo.count > 1 ? 's' : ''} Pending
                                    </h3>
                                    <p className="text-white text-base font-semibold mb-2">थोड़ा समय लग रहा है</p>
                                    <div className="bg-white/10 backdrop-blur-sm inline-block px-4 py-2 rounded-full">
                                        <p className="text-yellow-300 text-sm font-medium">
                                            ⏰ Time Taken: {pendingWithdrawalInfo.oldest_time}
                                        </p>
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="px-6 py-5 bg-gradient-to-b from-gray-50 to-white">

                                    {/* Trust Message */}
                                    <div className="bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-300 rounded-xl p-4 mb-4">
                                        <div className="flex items-start gap-3">
                                            <div className="text-3xl mt-0.5">✅</div>
                                            <div className="flex-1">
                                                <p className="text-sm font-bold text-green-800 mb-2">
                                                    हम 100% भरोसेमंद हैं!
                                                </p>
                                                <p className="text-xs text-green-700 leading-relaxed mb-2">
                                                    Banking की समस्या के कारण withdrawal में थोड़ा समय लग रहा है। आपका पैसा जल्द ही आपके खाते में भेज दिया जाएगा।
                                                </p>
                                                <div className="border-t border-green-200 pt-2 mt-2">
                                                    <p className="text-sm font-bold text-green-800 mb-1">
                                                        We are 100% Trusted!
                                                    </p>
                                                    <p className="text-xs text-green-700 leading-relaxed">
                                                        It's taking a little time to complete the withdrawal due to banking issues. You will receive your money shortly.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Action Button */}
                                    <button
                                        onClick={() => setShowPendingDialog(false)}
                                        className="w-full py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-all text-base"
                                    >
                                        समझ गया / Got It
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </Modal>

                {/* <Modal isOpen={paymentMethodModal} toggle={()=>setPaymentMethodModal(false )} >
          <div style={{width:"400px",margin:"0 auto",maxWidth:"90vw"}}>
             <div className="grid grid-cols-3 p-2 font-semibold text-white bg-primary">
                <div></div>
                <div className="text-center">Add Balance</div>
                <div className="flex justify-end">
                  <button type="button" onClick={()=>setPaymentMethodModal(false)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18 18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
          </div>
          <div className="flex flex-col px-3 pb-3">
            <br />
              <label className="text-sm font-bold">Payment Method</label>
              <select
                className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                required
                value={addBalanceMethod}
                onChange={(e) => {setAddBalanceMethod(e.target.value); setBalanceMethodData(null)}}
              >
                {appData.enable_upi_withdraw === 1 && (
                  <option value={"upi"}>UPI</option>
                )}
                {appData.enable_bank_withdraw === 1 && (
                  <option value={"bank"}>Bank</option>
                )}
              </select>
            </div>
            {addBalanceMethod === "upi" ? (
              <form onSubmit={_addBalanceUPI}>
                <div className="px-3 text-sm">
                  <div className="flex flex-col">
                    <input
                      className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                      type="text"
                      placeholder="UPI id"
                      name="upi_id"
                      id="upi_id"
                      key={"upi"}
                      defaultValue={ defaultWithdrawDetails?.upi_id || ""}
                      required
                    />
                  </div>
                </div>
                <button
                  style={{background:"#0098c7"}}
                  type="submit"
                  className="mt-4 ml-1 py-2 px-5 text-sm font-semibold text-white rounded-3xl"
                >
                  Submit
                </button>
              </form>
            ) : (
              <form onSubmit={_addBalanceBank}>
                <div className="px-3 text-sm">
                  <div className="flex flex-col pb-1">
                    <input
                      className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                      type="text"
                      placeholder="Enter Bank Name"
                      name="bank_name"
                      id="bank_name"
                      key="bankName"
                      defaultValue={defaultWithdrawDetails?.bank_name || ""}
                      required
                    />
                  </div>
                  <div className="flex flex-col pb-1">
                    <input
                      className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                      type="text"
                      placeholder="Enter Account Holder Name"
                      name="account_holder_name"
                      id="account_holder_name"
                      defaultValue={ defaultWithdrawDetails?.account_holder_name || ""}
                      required
                    />
                  </div>
                  <div className="flex flex-col pb-1">
                    <input
                      className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                      type="number"
                      placeholder="Enter Account Number"
                      name="account_number"
                      id="account_number"
                      required
                      defaultValue={defaultWithdrawDetails?.account_number || ""}
                    />
                  </div>
                  <div className="flex flex-col">
                    <input
                      className="px-2 py-1 mt-1 text-black border rounded h-9 border-black/30"
                      type="text"
                      placeholder="Enter IFSC Code"
                      name="account_ifsc_code"
                      id="account_ifsc_code"
                      required
                    />
                  </div>
                </div>
                <button
                  style={{background:"#0098c7"}}
                  type="submit"
                  className="mt-4 ml-1 py-2 px-5 text-sm font-semibold text-white rounded-3xl"
                >
                  Submit
                </button>
              </form>
            )}
            <br />
          </div>
        </Modal> */}
            </div>
        </>
    );
};

export default Wallet;
